import { render, staticRenderFns } from "./BaseGeneralIndicators.vue?vue&type=template&id=f004a3c8&scoped=true"
import script from "./BaseGeneralIndicators.vue?vue&type=script&lang=js"
export * from "./BaseGeneralIndicators.vue?vue&type=script&lang=js"
import style0 from "./BaseGeneralIndicators.vue?vue&type=style&index=0&id=f004a3c8&prod&lang=scss&scoped=true"
import style1 from "./BaseGeneralIndicators.vue?vue&type=style&index=1&id=f004a3c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f004a3c8",
  null
  
)

export default component.exports